<template>
  <div style="padding: 5px;">
    <a-card>
      <div class="ant-descriptions-title">Cấu trúc phòng ban</div>
      <a-tree
        :show-line="showLine"
        :show-icon="showIcon"
        :defaultExpandAll="true"
        @select="onSelect"
        :loadData="onLoadTreeData"
        :tree-data="treeDatas"
      >
        <!-- <a-tree-node key="0-0-0" title="parent 1-0">
            <a-icon slot="icon" type="carry-out" />
            <a-tree-node key="0-0-0-0" title="leaf">
              <a-icon slot="icon" type="carry-out" />
            </a-tree-node>
            <a-tree-node key="0-0-0-1" title="leaf">
              <a-icon slot="icon" type="carry-out" />
            </a-tree-node>
            <a-tree-node key="0-0-0-2" title="leaf">
              <a-icon slot="icon" type="carry-out" />
            </a-tree-node>
          </a-tree-node>
          <a-tree-node key="0-0-1" title="parent 1-1">
            <a-icon slot="icon" type="carry-out" />
            <a-tree-node key="0-0-1-0" title="leaf">
              <a-icon slot="icon" type="carry-out" />
            </a-tree-node>
          </a-tree-node>
          <a-tree-node key="0-0-2" title="parent 1-2">
            <a-icon slot="icon" type="carry-out" />
            <a-tree-node key="0-0-2-0" title="leaf">
              <a-icon slot="icon" type="carry-out" />
              <a-tree-node key="0-0-2-0" title="leaf">
                <a-icon slot="icon" type="carry-out" />
              </a-tree-node>
            </a-tree-node>
            <a-tree-node key="0-0-2-1" title="leaf">
              <a-icon slot="icon" type="carry-out" />
              <a-icon slot="switcherIcon" type="form" />
            </a-tree-node>
          </a-tree-node> -->
      </a-tree>
    </a-card>
  </div>
</template>
<script>
import query from "../data/getData";
const limit = 1000;
export default {
  data() {
    return {
      showLine: true,
      showIcon: false,
      loading: false,
      loadingItem: false,
      filter: {},
      datas: [],
      treeDatas: [],
    };
  },
  methods: {
    onGetListDepartmentParent() {
      this.loading = true;
      this.$apollo
        .query({
          query: query.getListDepartmentParent,
          variables: {
            status: this.filter.status,
            limit,
            page: this.totalPage,
            query: this.filter.query,
          },
          fetchPolicy: "no-cache",
        })
        .then(({ data }) => {
          if (data?.getListDepartmentParent?.length >= 0) {
            this.datas = [...data.getListDepartmentParent];
            // convert data to tree data
            this.onConvertToTreeData(this.datas);
          }
          this.loading = false;
        })
        .catch((error) => {
          console.log("Không lấy được danh sách phòng ban", error);
          this.loading = false;
        });
    },
    onGetDepartment(idDepartment) {
      return this.$apollo.query({
        query: query.queryGetDepartment,
        variables: {
          id: idDepartment,
        },
        fetchPolicy: "no-cache",
      });
    },
    onSelect(selectedKeys, info) {
      console.log("selected", selectedKeys, info);
    },
    onLoadTreeData(treeNode) {
      return new Promise((resolve) => {
        if (treeNode.dataRef.children) {
          resolve();
          return;
        }
        const idDepartment = treeNode.value;
        if (!idDepartment) {
          resolve();
          return null;
        }
        this.onGetDepartment(idDepartment)
          .then(({ data }) => {
            if (data?.getDepartment?.children?.length > 0) {
              // tìm đúng department cha để mà bind vào
              // const findIndex
              treeNode.dataRef.children = data.getDepartment.children.map(
                (e) => ({
                  title: e.name,
                  value: e.id,
                })
              );
              this.treeDatas = [...this.treeDatas];
            }
            resolve();
          })
          .catch((error) => {
            console.log("Không lấy được danh sách phòng ban", error);
          });
        console.log(treeNode);
      });
    },
    onConvertToTreeData(departments) {
      if (departments?.length > 0) {
        this.treeDatas = departments.map((e) => ({
          title: e.name,
          value: e.id,
        }));
      }
    },
  },
  created() {
    this.onGetListDepartmentParent();
  },
};
</script>
